import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=5787a682&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"
import style0 from "./ProjectOverview.vue?vue&type=style&index=0&id=5787a682&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787a682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5787a682')) {
      api.createRecord('5787a682', component.options)
    } else {
      api.reload('5787a682', component.options)
    }
    module.hot.accept("./ProjectOverview.vue?vue&type=template&id=5787a682&scoped=true", function () {
      api.rerender('5787a682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/ProjectOverview.vue"
export default component.exports